const YoutubeIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-youtube 1'>
      <path
        id='Vector'
        d='M21.8846 6.95982C21.6933 5.9042 20.7821 5.13545 19.7246 4.89545C18.1421 4.55982 15.2133 4.31982 12.0446 4.31982C8.87769 4.31982 5.90207 4.55982 4.31769 4.89545C3.26207 5.13545 2.34894 5.85545 2.15769 6.95982C1.96457 8.15982 1.77332 9.83982 1.77332 11.9998C1.77332 14.1598 1.96457 15.8398 2.20457 17.0398C2.39769 18.0954 3.30894 18.8642 4.36457 19.1042C6.04457 19.4398 8.92457 19.6798 12.0933 19.6798C15.2621 19.6798 18.1421 19.4398 19.8221 19.1042C20.8777 18.8642 21.7889 18.1442 21.9821 17.0398C22.1733 15.8398 22.4133 14.1111 22.4621 11.9998C22.3646 9.83982 22.1246 8.15982 21.8846 6.95982ZM9.45332 15.3598V8.63982L15.3089 11.9998L9.45332 15.3598Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default YoutubeIcon
